import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toaster } from "@/utils/toaster";
import type { Template } from "./types";

export function useTemplates(url: string): {
  templates: Template[];
  isLoading: boolean;
} {
  const { t } = useTranslation();
  const [templates, setTemplates] = useState<Template[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();
    setIsLoading(true);
    setTemplates([]);

    fetch(url, { signal: controller.signal })
      .then(async (res) => {
        if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
        const data = (await res.json()) as Template[];
        if (!controller.signal.aborted) {
          setTemplates(data);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        if (controller.signal.aborted) return;
        console.error("Fetch error:", err);
        toaster("error", t("error_occurred"), { closeButton: true });
        setTemplates([]);
        setIsLoading(false);
      });

    return () => controller.abort();
  }, [url, t]);

  return { templates, isLoading };
}
